// ─────────────────────────────────────────────────────────────────────────────
// CLAIMS LODGEMENT QUESTIONNAIRES
// One questionnaire per policy type.
// Each questionnaire has sections → fields.
// field types: text | textarea | date | time | select | radio | checkbox
// ─────────────────────────────────────────────────────────────────────────────

export const CLAIM_QUESTIONNAIRES = {

  // ── MOTOR (Car / Commercial Motor / Truck / Motorbike) ────────────────────
  Motor: {
    label: 'Motor Vehicle',
    icon: '🚗',
    appliesTo: ['Car', 'Commercial Motor', 'Truck', 'Motorbike', 'Caravan'],
    sections: [
      {
        title: 'Policy Details',
        fields: [
          { key: 'policy_number',    label: 'Policy Number',              type: 'text' },
          { key: 'insured_name',     label: 'Insured Name',               type: 'text' },
          { key: 'contact_number',   label: 'Contact Number',             type: 'text' },
          { key: 'email',            label: 'Email Address',              type: 'text' },
          { key: 'abn',              label: 'ABN (if applicable)',         type: 'text' },
          { key: 'best_contact',     label: 'Best Contact Person',        type: 'text' },
        ],
      },
      {
        title: 'Incident Details',
        fields: [
          { key: 'incident_date',     label: 'Date of Incident',                      type: 'date' },
          { key: 'incident_time',     label: 'Time of Incident',                      type: 'time' },
          { key: 'incident_location', label: 'Exact Location of Incident',             type: 'text' },
          { key: 'incident_type',     label: 'Type of Incident',                      type: 'select', options: ['Collision / Accident', 'Theft / Attempted Theft', 'Storm / Hail / Flood', 'Fire', 'Vandalism', 'Windscreen / Glass', 'Other'] },
          { key: 'police_attended',   label: 'Police Attendance Required?',           type: 'radio',  options: ['Yes', 'No'] },
          { key: 'police_event',      label: 'Police Event Number (if applicable)',   type: 'text' },
          { key: 'injuries',          label: 'Any Injuries Involved?',                type: 'radio',  options: ['Yes', 'No'] },
          { key: 'ambulance',         label: 'Ambulance Attended?',                   type: 'radio',  options: ['Yes', 'No'] },
          { key: 'incident_description', label: 'Version of Events — full description of how the incident occurred', type: 'textarea' },
        ],
      },
      {
        title: 'Driver Details',
        fields: [
          { key: 'driver_name',         label: 'Full Name of Driver',                        type: 'text' },
          { key: 'driver_dob',          label: 'Date of Birth',                              type: 'date' },
          { key: 'driver_licence',      label: 'Licence Number',                             type: 'text' },
          { key: 'driver_licence_state',label: 'Licence State',                              type: 'select', options: ['QLD','NSW','VIC','SA','WA','TAS','NT','ACT'] },
          { key: 'driver_licence_type', label: 'Licence Type',                               type: 'select', options: ['Open', 'Provisional', 'Learner', 'Heavy Vehicle', 'Other'] },
          { key: 'driver_alcohol_drugs',label: 'Alcohol or Drugs Consumed in Last 12 Hours?',type: 'radio',  options: ['Yes', 'No'] },
          { key: 'driver_restrictions', label: 'Any Driving Restrictions or Conditions?',    type: 'radio',  options: ['Yes', 'No'] },
          { key: 'driver_restrictions_detail', label: 'If yes, details',                     type: 'text' },
        ],
      },
      {
        title: 'Insured Vehicle Details',
        fields: [
          { key: 'vehicle_rego',        label: 'Vehicle Registration',               type: 'text' },
          { key: 'vehicle_make_model',  label: 'Make & Model',                       type: 'text' },
          { key: 'vehicle_damage',      label: 'Description of Damage',              type: 'textarea' },
          { key: 'vehicle_drivable',    label: 'Is the Vehicle Currently Drivable?', type: 'radio',   options: ['Yes', 'No'] },
          { key: 'vehicle_not_drivable_reason', label: 'If not drivable, why?',      type: 'text' },
          { key: 'vehicle_location',    label: 'Current Location of Vehicle',        type: 'text' },
          { key: 'towing_required',     label: 'Towing Required?',                   type: 'radio',   options: ['Yes', 'No'] },
          { key: 'preferred_repairer',  label: 'Preferred Repairer (if known)',      type: 'text' },
          { key: 'accessories_damaged', label: 'Any Accessories or Tools Damaged / Stolen?', type: 'textarea' },
        ],
      },
      {
        title: 'Third Party Details',
        fields: [
          { key: 'tp_name',    label: 'Third Party Name',         type: 'text' },
          { key: 'tp_phone',   label: 'Third Party Phone Number', type: 'text' },
          { key: 'tp_address', label: 'Third Party Address',      type: 'text' },
          { key: 'tp_rego',    label: 'Third Party Vehicle Rego', type: 'text' },
          { key: 'tp_insurer', label: 'Third Party Insurer (if known)', type: 'text' },
        ],
      },
      {
        title: 'Witness Details',
        fields: [
          { key: 'witness_name',    label: 'Witness Name',           type: 'text' },
          { key: 'witness_phone',   label: 'Witness Contact Number', type: 'text' },
          { key: 'witness_summary', label: 'Summary of What They Saw', type: 'textarea' },
        ],
      },
      {
        title: 'Photos & Documents Requested',
        fields: [
          { key: 'docs_checklist', label: 'Confirm items requested from client', type: 'checkbox', options: [
            'Photos of all vehicle damage',
            'Photos of accident scene',
            'Dashcam footage (if available)',
            'Third party details',
            'Police report / event number',
            'Tow invoice (if applicable)',
          ]},
        ],
      },
      {
        title: 'Broker Actions',
        fields: [
          { key: 'lodged_with_insurer',    label: 'Claim Lodged with Insurer?',       type: 'radio', options: ['Yes', 'No'] },
          { key: 'claim_number',           label: 'Claim Number',                     type: 'text' },
          { key: 'assessor_appointed',     label: 'Assessor Appointed?',              type: 'radio', options: ['Yes', 'No', 'Pending'] },
          { key: 'excess_advised',         label: 'Client Advised of Excess?',        type: 'radio', options: ['Yes', 'No'] },
          { key: 'hire_car_discussed',     label: 'Hire Car Discussed?',              type: 'radio', options: ['Yes', 'No', 'N/A'] },
          { key: 'diary_task_created',     label: 'Follow-up Diary Task Created?',    type: 'radio', options: ['Yes', 'No'] },
          { key: 'client_updated',         label: 'Client Updated via Phone / Email?',type: 'radio', options: ['Yes', 'No'] },
          { key: 'additional_notes',       label: 'Additional Notes',                 type: 'textarea' },
        ],
      },
    ],
  },

  // ── PROPERTY (Commercial Property / Landlord / Home & Contents) ───────────
  Property: {
    label: 'Property',
    icon: '🏢',
    appliesTo: ['Commercial Property', 'Landlord', 'Home & Contents', 'Residential Strata'],
    sections: [
      {
        title: 'Policy Details',
        fields: [
          { key: 'policy_number',  label: 'Policy Number',     type: 'text' },
          { key: 'insured_name',   label: 'Insured Name',      type: 'text' },
          { key: 'contact_number', label: 'Contact Number',    type: 'text' },
          { key: 'email',          label: 'Email Address',     type: 'text' },
          { key: 'abn',            label: 'ABN (if applicable)', type: 'text' },
        ],
      },
      {
        title: 'Incident Details',
        fields: [
          { key: 'incident_date',     label: 'Date of Incident / Discovery',   type: 'date' },
          { key: 'incident_time',     label: 'Time (approx)',                  type: 'time' },
          { key: 'risk_address',      label: 'Insured Property Address',       type: 'text' },
          { key: 'incident_type',     label: 'Cause of Loss',                  type: 'select', options: ['Storm / Hail / Flood', 'Fire', 'Burglary / Theft', 'Malicious Damage / Vandalism', 'Water Damage / Burst Pipe', 'Accidental Damage', 'Impact (vehicle, tree, etc.)', 'Subsidence / Landslip', 'Earthquake', 'Other'] },
          { key: 'police_attended',   label: 'Police Attendance Required?',   type: 'radio',  options: ['Yes', 'No'] },
          { key: 'police_event',      label: 'Police Event Number',            type: 'text' },
          { key: 'injuries',          label: 'Any Injuries?',                  type: 'radio',  options: ['Yes', 'No'] },
          { key: 'incident_description', label: 'Full Description of Incident', type: 'textarea' },
        ],
      },
      {
        title: 'Property Damage Details',
        fields: [
          { key: 'areas_affected',       label: 'Areas / Sections of Property Affected',   type: 'textarea' },
          { key: 'building_damage',      label: 'Description of Building Damage',           type: 'textarea' },
          { key: 'contents_damage',      label: 'Description of Contents Damaged / Stolen', type: 'textarea' },
          { key: 'property_secure',      label: 'Is the Property Currently Secure?',        type: 'radio',   options: ['Yes', 'No'] },
          { key: 'property_habitable',   label: 'Is the Property Still Habitable / Operational?', type: 'radio', options: ['Yes', 'No'] },
          { key: 'emergency_works',      label: 'Any Emergency Works Already Undertaken?',  type: 'radio',   options: ['Yes', 'No'] },
          { key: 'emergency_works_detail', label: 'If yes, describe and provide invoices',  type: 'textarea' },
          { key: 'estimated_loss',       label: 'Estimated Value of Loss / Damage (approx)', type: 'text' },
          { key: 'photos_taken',         label: 'Photos / Video of Damage Taken?',           type: 'radio',   options: ['Yes', 'No'] },
        ],
      },
      {
        title: 'Tenant Details (Landlord policies)',
        fields: [
          { key: 'tenant_name',    label: 'Tenant Name',           type: 'text' },
          { key: 'tenant_phone',   label: 'Tenant Phone',          type: 'text' },
          { key: 'tenant_vacated', label: 'Has Tenant Vacated?',   type: 'radio', options: ['Yes', 'No', 'N/A'] },
          { key: 'rent_arrears',   label: 'Are Rent Arrears Involved?', type: 'radio', options: ['Yes', 'No', 'N/A'] },
          { key: 'property_manager', label: 'Property Manager Name & Contact', type: 'text' },
        ],
      },
      {
        title: 'Photos & Documents Requested',
        fields: [
          { key: 'docs_checklist', label: 'Confirm items requested from client', type: 'checkbox', options: [
            'Photos / video of all damage',
            'Photos of any storm / weather event context',
            'Receipts or valuations for damaged contents',
            'Police report / event number',
            'Any emergency repair invoices',
            'Lease agreement (Landlord claims)',
            'Rent ledger / arrears statement (Landlord claims)',
          ]},
        ],
      },
      {
        title: 'Broker Actions',
        fields: [
          { key: 'lodged_with_insurer',  label: 'Claim Lodged with Insurer?',         type: 'radio', options: ['Yes', 'No'] },
          { key: 'claim_number',         label: 'Claim Number',                       type: 'text' },
          { key: 'assessor_appointed',   label: 'Assessor / Loss Adjuster Appointed?',type: 'radio', options: ['Yes', 'No', 'Pending'] },
          { key: 'excess_advised',       label: 'Client Advised of Excess?',          type: 'radio', options: ['Yes', 'No'] },
          { key: 'alt_accommodation',    label: 'Alternative Accommodation Discussed?',type: 'radio', options: ['Yes', 'No', 'N/A'] },
          { key: 'diary_task_created',   label: 'Follow-up Diary Task Created?',      type: 'radio', options: ['Yes', 'No'] },
          { key: 'client_updated',       label: 'Client Updated via Phone / Email?',  type: 'radio', options: ['Yes', 'No'] },
          { key: 'additional_notes',     label: 'Additional Notes',                   type: 'textarea' },
        ],
      },
    ],
  },

  // ── PUBLIC LIABILITY ───────────────────────────────────────────────────────
  PublicLiability: {
    label: 'Public Liability',
    icon: '🦺',
    appliesTo: ['Public Liability'],
    sections: [
      {
        title: 'Policy Details',
        fields: [
          { key: 'policy_number',  label: 'Policy Number',       type: 'text' },
          { key: 'insured_name',   label: 'Insured Name',        type: 'text' },
          { key: 'contact_number', label: 'Contact Number',      type: 'text' },
          { key: 'email',          label: 'Email Address',       type: 'text' },
          { key: 'abn',            label: 'ABN',                 type: 'text' },
          { key: 'business_activity', label: 'Business Activity at Time of Incident', type: 'text' },
        ],
      },
      {
        title: 'Incident Details',
        fields: [
          { key: 'incident_date',        label: 'Date of Incident',              type: 'date' },
          { key: 'incident_time',        label: 'Time of Incident',              type: 'time' },
          { key: 'incident_location',    label: 'Exact Location / Address',      type: 'text' },
          { key: 'incident_type',        label: 'Nature of Incident',            type: 'select', options: ['Bodily Injury to Third Party', 'Property Damage to Third Party', 'Both Bodily Injury & Property Damage', 'Products Liability', 'Other'] },
          { key: 'incident_description', label: 'Full Description of Incident',  type: 'textarea' },
          { key: 'police_attended',      label: 'Police Attended?',              type: 'radio', options: ['Yes', 'No'] },
          { key: 'police_event',         label: 'Police Event Number',           type: 'text' },
          { key: 'liability_admitted',   label: 'Was Liability Admitted at Scene?', type: 'radio', options: ['Yes', 'No'] },
          { key: 'liability_admitted_detail', label: 'If yes, what was said or done?', type: 'textarea' },
        ],
      },
      {
        title: 'Claimant Details (Third Party)',
        fields: [
          { key: 'claimant_name',    label: 'Claimant Full Name',    type: 'text' },
          { key: 'claimant_dob',     label: 'Claimant Date of Birth',type: 'date' },
          { key: 'claimant_phone',   label: 'Claimant Phone',        type: 'text' },
          { key: 'claimant_address', label: 'Claimant Address',      type: 'text' },
          { key: 'claimant_email',   label: 'Claimant Email',        type: 'text' },
          { key: 'claimant_lawyer',  label: 'Has Claimant Engaged a Lawyer?', type: 'radio', options: ['Yes', 'No', 'Unknown'] },
          { key: 'claimant_lawyer_detail', label: 'If yes, lawyer name & firm', type: 'text' },
        ],
      },
      {
        title: 'Injury / Damage Details',
        fields: [
          { key: 'injury_description',   label: 'Description of Injury / Damage', type: 'textarea' },
          { key: 'medical_treatment',    label: 'Medical Treatment Received?',     type: 'radio',   options: ['Yes', 'No'] },
          { key: 'medical_detail',       label: 'Hospital / Doctor / Treatment Details', type: 'text' },
          { key: 'property_damage_desc', label: 'Description of Property Damaged', type: 'textarea' },
          { key: 'estimated_claim',      label: 'Estimated Value of Claim (if known)', type: 'text' },
          { key: 'demand_received',      label: 'Any Formal Demand / Letter of Claim Received?', type: 'radio', options: ['Yes', 'No'] },
        ],
      },
      {
        title: 'Witness Details',
        fields: [
          { key: 'witness_name',    label: 'Witness Name',            type: 'text' },
          { key: 'witness_phone',   label: 'Witness Phone',           type: 'text' },
          { key: 'witness_summary', label: 'What the Witness Saw',    type: 'textarea' },
        ],
      },
      {
        title: 'Photos & Documents Requested',
        fields: [
          { key: 'docs_checklist', label: 'Confirm items requested from client', type: 'checkbox', options: [
            'Photos of injury / damage',
            'Photos of incident location',
            'Any formal demand letter or legal correspondence',
            'Police report',
            'CCTV or dashcam footage (if available)',
            'Any written statements from witnesses',
            'Relevant contracts or service agreements',
            'Product details / batch numbers (products claims)',
          ]},
        ],
      },
      {
        title: 'Broker Actions',
        fields: [
          { key: 'lodged_with_insurer', label: 'Claim Lodged with Insurer?',        type: 'radio', options: ['Yes', 'No'] },
          { key: 'claim_number',        label: 'Claim Number',                      type: 'text' },
          { key: 'liability_warned',    label: 'Client Warned NOT to Admit Liability?', type: 'radio', options: ['Yes', 'No'] },
          { key: 'solicitor_involved',  label: 'Insurer / Panel Solicitor Involved?',type: 'radio', options: ['Yes', 'No', 'Pending'] },
          { key: 'excess_advised',      label: 'Client Advised of Excess?',         type: 'radio', options: ['Yes', 'No'] },
          { key: 'diary_task_created',  label: 'Follow-up Diary Task Created?',     type: 'radio', options: ['Yes', 'No'] },
          { key: 'client_updated',      label: 'Client Updated?',                   type: 'radio', options: ['Yes', 'No'] },
          { key: 'additional_notes',    label: 'Additional Notes',                  type: 'textarea' },
        ],
      },
    ],
  },

  // ── PROFESSIONAL INDEMNITY ─────────────────────────────────────────────────
  ProfessionalIndemnity: {
    label: 'Professional Indemnity',
    icon: '⚖️',
    appliesTo: ['Professional Indemnity'],
    sections: [
      {
        title: 'Policy Details',
        fields: [
          { key: 'policy_number',     label: 'Policy Number',           type: 'text' },
          { key: 'insured_name',      label: 'Insured Name',            type: 'text' },
          { key: 'contact_number',    label: 'Contact Number',          type: 'text' },
          { key: 'email',             label: 'Email Address',           type: 'text' },
          { key: 'profession',        label: 'Profession / Service Provided', type: 'text' },
          { key: 'policy_period',     label: 'Policy Period (from–to)',  type: 'text' },
          { key: 'claims_made_noted', label: 'Client reminded this is a Claims-Made policy?', type: 'radio', options: ['Yes', 'No'] },
        ],
      },
      {
        title: 'Claim / Circumstance Details',
        fields: [
          { key: 'claim_or_circumstance', label: 'Is this a Claim or Circumstance?', type: 'radio', options: ['Formal Claim / Demand', 'Circumstance / Potential Claim'] },
          { key: 'date_of_act',         label: 'Date the Alleged Act / Omission Occurred', type: 'date' },
          { key: 'date_claim_received', label: 'Date Claim / Demand First Received',       type: 'date' },
          { key: 'date_first_aware',    label: 'Date Insured First Became Aware',           type: 'date' },
          { key: 'nature_of_claim',     label: 'Nature of Claim / Allegation',             type: 'select', options: ['Negligent Advice', 'Error / Omission', 'Breach of Duty', 'Misleading / Deceptive Conduct', 'Breach of Contract', 'IP Infringement', 'Other'] },
          { key: 'claim_description',   label: 'Full Description of Claim / Circumstance', type: 'textarea' },
          { key: 'services_provided',   label: 'What Services Were Provided to the Claimant?', type: 'textarea' },
          { key: 'estimated_loss',      label: 'Estimated Value of Claim (if known)',       type: 'text' },
        ],
      },
      {
        title: 'Claimant Details',
        fields: [
          { key: 'claimant_name',    label: 'Claimant Name / Company', type: 'text' },
          { key: 'claimant_phone',   label: 'Claimant Phone',          type: 'text' },
          { key: 'claimant_email',   label: 'Claimant Email',          type: 'text' },
          { key: 'claimant_address', label: 'Claimant Address',        type: 'text' },
          { key: 'claimant_lawyer',  label: 'Has Claimant Engaged a Lawyer?',    type: 'radio', options: ['Yes', 'No', 'Unknown'] },
          { key: 'claimant_lawyer_detail', label: 'If yes, lawyer name & firm',  type: 'text' },
        ],
      },
      {
        title: 'Documents Requested',
        fields: [
          { key: 'docs_checklist', label: 'Confirm items requested from client', type: 'checkbox', options: [
            'Letter of demand / formal claim',
            'Any legal proceedings / court documents',
            'Service agreement / contract with claimant',
            'Copies of all advice / reports / correspondence relating to the claim',
            'File notes or records of work performed',
            'Any response already sent to the claimant',
            'Evidence of the alleged error or omission',
          ]},
        ],
      },
      {
        title: 'Broker Actions',
        fields: [
          { key: 'lodged_with_insurer',   label: 'Notified Insurer?',                   type: 'radio', options: ['Yes', 'No'] },
          { key: 'claim_number',          label: 'Claim / Reference Number',            type: 'text' },
          { key: 'panel_solicitor',       label: 'Panel Solicitor Appointed?',           type: 'radio', options: ['Yes', 'No', 'Pending'] },
          { key: 'no_admission_warned',   label: 'Client Warned NOT to Admit Liability or Settle Without Insurer Consent?', type: 'radio', options: ['Yes', 'No'] },
          { key: 'excess_advised',        label: 'Client Advised of Excess?',           type: 'radio', options: ['Yes', 'No'] },
          { key: 'diary_task_created',    label: 'Follow-up Diary Task Created?',       type: 'radio', options: ['Yes', 'No'] },
          { key: 'client_updated',        label: 'Client Updated?',                     type: 'radio', options: ['Yes', 'No'] },
          { key: 'additional_notes',      label: 'Additional Notes',                    type: 'textarea' },
        ],
      },
    ],
  },

  // ── MANAGEMENT LIABILITY ───────────────────────────────────────────────────
  ManagementLiability: {
    label: 'Management Liability',
    icon: '🏛️',
    appliesTo: ['Management Liability'],
    sections: [
      {
        title: 'Policy Details',
        fields: [
          { key: 'policy_number',  label: 'Policy Number',  type: 'text' },
          { key: 'insured_name',   label: 'Insured Name',   type: 'text' },
          { key: 'contact_number', label: 'Contact Number', type: 'text' },
          { key: 'email',          label: 'Email Address',  type: 'text' },
          { key: 'section_triggered', label: 'Policy Section Triggered', type: 'select', options: ["Directors & Officers (D&O)", "Employment Practices Liability (EPL)", "Crime / Fidelity", "Statutory Liability", "Corporate Liability", "Other"] },
        ],
      },
      {
        title: 'Claim / Circumstance Details',
        fields: [
          { key: 'claim_or_circumstance', label: 'Is this a Claim or Circumstance?',    type: 'radio', options: ['Formal Claim / Demand', 'Circumstance / Potential Claim'] },
          { key: 'date_of_act',           label: 'Date the Alleged Act Occurred',        type: 'date' },
          { key: 'date_claim_received',   label: 'Date Claim / Demand First Received',   type: 'date' },
          { key: 'date_first_aware',      label: 'Date Insured First Became Aware',       type: 'date' },
          { key: 'nature_of_claim',       label: 'Nature of Claim',                      type: 'select', options: ['Wrongful Act by Director / Officer', 'Unfair Dismissal / Workplace Claim', 'Harassment / Discrimination', 'Fraud / Dishonesty by Employee', 'Breach of Statutory Duty', 'Regulatory Investigation', 'Other'] },
          { key: 'regulator_involved',    label: 'Regulator Involved? (ASIC, Fair Work, ATO etc.)', type: 'radio', options: ['Yes', 'No'] },
          { key: 'regulator_detail',      label: 'If yes, which regulator and nature of investigation', type: 'text' },
          { key: 'claim_description',     label: 'Full Description of Claim',            type: 'textarea' },
          { key: 'estimated_loss',        label: 'Estimated Value of Claim (if known)',  type: 'text' },
        ],
      },
      {
        title: 'Claimant Details',
        fields: [
          { key: 'claimant_name',    label: 'Claimant Name',         type: 'text' },
          { key: 'claimant_phone',   label: 'Claimant Phone',        type: 'text' },
          { key: 'claimant_address', label: 'Claimant Address',      type: 'text' },
          { key: 'claimant_lawyer',  label: 'Has Claimant Engaged a Lawyer?', type: 'radio', options: ['Yes', 'No', 'Unknown'] },
          { key: 'claimant_lawyer_detail', label: 'Lawyer Name & Firm', type: 'text' },
        ],
      },
      {
        title: 'Documents Requested',
        fields: [
          { key: 'docs_checklist', label: 'Confirm items requested from client', type: 'checkbox', options: [
            'Letter of demand / formal claim',
            'Any legal proceedings / court documents',
            'Employment contracts / HR records (EPL)',
            'Board minutes / resolutions (D&O)',
            'Financial records (if relevant)',
            'Regulator correspondence',
            'Any internal investigation reports',
          ]},
        ],
      },
      {
        title: 'Broker Actions',
        fields: [
          { key: 'lodged_with_insurer',  label: 'Notified Insurer?',             type: 'radio', options: ['Yes', 'No'] },
          { key: 'claim_number',         label: 'Claim / Reference Number',      type: 'text' },
          { key: 'panel_solicitor',      label: 'Panel Solicitor Appointed?',    type: 'radio', options: ['Yes', 'No', 'Pending'] },
          { key: 'no_admission_warned',  label: 'Client Warned NOT to Admit Liability or Settle Without Insurer Consent?', type: 'radio', options: ['Yes', 'No'] },
          { key: 'excess_advised',       label: 'Client Advised of Excess?',     type: 'radio', options: ['Yes', 'No'] },
          { key: 'diary_task_created',   label: 'Follow-up Diary Task Created?', type: 'radio', options: ['Yes', 'No'] },
          { key: 'client_updated',       label: 'Client Updated?',               type: 'radio', options: ['Yes', 'No'] },
          { key: 'additional_notes',     label: 'Additional Notes',              type: 'textarea' },
        ],
      },
    ],
  },

  // ── MARINE / CARGO ─────────────────────────────────────────────────────────
  Marine: {
    label: 'Marine / Cargo',
    icon: '⚓',
    appliesTo: ['Marine', 'Carriers'],
    sections: [
      {
        title: 'Policy Details',
        fields: [
          { key: 'policy_number',  label: 'Policy Number',     type: 'text' },
          { key: 'insured_name',   label: 'Insured Name',      type: 'text' },
          { key: 'contact_number', label: 'Contact Number',    type: 'text' },
          { key: 'email',          label: 'Email Address',     type: 'text' },
          { key: 'marine_type',    label: 'Marine Cover Type', type: 'select', options: ['Cargo / Goods in Transit', 'Carriers Liability', 'Hull / Pleasure Craft', 'Marine Liability', 'Other'] },
        ],
      },
      {
        title: 'Incident Details',
        fields: [
          { key: 'incident_date',        label: 'Date of Incident / Discovery', type: 'date' },
          { key: 'incident_location',    label: 'Location of Loss',             type: 'text' },
          { key: 'incident_type',        label: 'Cause of Loss',                type: 'select', options: ['Collision', 'Theft / Piracy', 'Damage in Transit', 'Fire / Explosion', 'Sinking / Grounding', 'Storm / Weather', 'Short Delivery', 'Non-Delivery', 'Contamination', 'Other'] },
          { key: 'incident_description', label: 'Full Description of Loss',     type: 'textarea' },
        ],
      },
      {
        title: 'Cargo / Vessel Details',
        fields: [
          { key: 'cargo_description',    label: 'Description of Goods / Cargo',      type: 'textarea' },
          { key: 'vessel_name',          label: 'Vessel Name (if applicable)',        type: 'text' },
          { key: 'voyage_from',          label: 'Voyage From',                       type: 'text' },
          { key: 'voyage_to',            label: 'Voyage To',                         type: 'text' },
          { key: 'bill_of_lading',       label: 'Bill of Lading / AWB Number',       type: 'text' },
          { key: 'invoice_value',        label: 'Invoice Value of Cargo',            type: 'text' },
          { key: 'estimated_loss',       label: 'Estimated Loss / Damage Value',     type: 'text' },
          { key: 'surveyor_required',    label: 'Surveyor Required?',                type: 'radio', options: ['Yes', 'No', 'Pending'] },
          { key: 'carrier_notified',     label: 'Carrier / Shipping Line Notified?', type: 'radio', options: ['Yes', 'No'] },
          { key: 'carrier_detail',       label: 'Carrier Name & Reference',          type: 'text' },
        ],
      },
      {
        title: 'Documents Requested',
        fields: [
          { key: 'docs_checklist', label: 'Confirm items requested from client', type: 'checkbox', options: [
            'Bill of lading / airway bill',
            'Commercial invoice',
            'Packing list',
            'Survey / inspection report',
            'Photos of damaged goods',
            'Delivery receipt showing damage notation',
            'Carrier claim correspondence',
            'Police report (theft)',
          ]},
        ],
      },
      {
        title: 'Broker Actions',
        fields: [
          { key: 'lodged_with_insurer', label: 'Claim Lodged with Insurer?',        type: 'radio', options: ['Yes', 'No'] },
          { key: 'claim_number',        label: 'Claim Number',                      type: 'text' },
          { key: 'surveyor_appointed',  label: 'Surveyor Appointed?',               type: 'radio', options: ['Yes', 'No', 'Pending'] },
          { key: 'excess_advised',      label: 'Client Advised of Excess?',         type: 'radio', options: ['Yes', 'No'] },
          { key: 'diary_task_created',  label: 'Follow-up Diary Task Created?',     type: 'radio', options: ['Yes', 'No'] },
          { key: 'client_updated',      label: 'Client Updated?',                   type: 'radio', options: ['Yes', 'No'] },
          { key: 'additional_notes',    label: 'Additional Notes',                  type: 'textarea' },
        ],
      },
    ],
  },

  // ── PLANT & EQUIPMENT / CONSTRUCTION ──────────────────────────────────────
  PlantEquipment: {
    label: 'Plant & Equipment / Construction',
    icon: '🔧',
    appliesTo: ['Plant & Equipment', 'Construction', 'Annual Works', 'Single Project', 'Owner Builder'],
    sections: [
      {
        title: 'Policy Details',
        fields: [
          { key: 'policy_number',  label: 'Policy Number',     type: 'text' },
          { key: 'insured_name',   label: 'Insured Name',      type: 'text' },
          { key: 'contact_number', label: 'Contact Number',    type: 'text' },
          { key: 'email',          label: 'Email Address',     type: 'text' },
          { key: 'cover_type',     label: 'Cover Type',        type: 'select', options: ['Plant & Equipment', 'Contract Works', 'Construction All Risks', 'Other'] },
        ],
      },
      {
        title: 'Incident Details',
        fields: [
          { key: 'incident_date',        label: 'Date of Incident',                   type: 'date' },
          { key: 'incident_time',        label: 'Time of Incident',                   type: 'time' },
          { key: 'incident_location',    label: 'Site Address / Location',            type: 'text' },
          { key: 'incident_type',        label: 'Cause of Loss',                      type: 'select', options: ['Accidental Damage', 'Theft', 'Rollover / Overturn', 'Collision', 'Fire', 'Flood / Storm', 'Breakdown / Mechanical Failure', 'Third Party Property Damage', 'Other'] },
          { key: 'incident_description', label: 'Full Description of Incident',       type: 'textarea' },
          { key: 'police_attended',      label: 'Police Attended? (theft / damage)',  type: 'radio', options: ['Yes', 'No'] },
          { key: 'police_event',         label: 'Police Event Number',                type: 'text' },
          { key: 'injuries',             label: 'Any Injuries?',                      type: 'radio', options: ['Yes', 'No'] },
          { key: 'worksafe_notified',    label: 'WorkSafe / WHS Authority Notified?', type: 'radio', options: ['Yes', 'No', 'N/A'] },
        ],
      },
      {
        title: 'Plant / Equipment Details',
        fields: [
          { key: 'plant_description',  label: 'Description of Plant / Equipment',  type: 'textarea' },
          { key: 'plant_rego',         label: 'Registration / Serial Number',       type: 'text' },
          { key: 'plant_damage',       label: 'Description of Damage',              type: 'textarea' },
          { key: 'plant_operable',     label: 'Is the Plant Currently Operable?',   type: 'radio', options: ['Yes', 'No'] },
          { key: 'plant_location',     label: 'Current Location of Plant',          type: 'text' },
          { key: 'estimated_loss',     label: 'Estimated Value of Damage / Loss',   type: 'text' },
          { key: 'operator_details',   label: 'Operator Name & Licence / Ticket',   type: 'text' },
          { key: 'project_name',       label: 'Project Name (Construction policies)', type: 'text' },
          { key: 'works_description',  label: 'Description of Works Underway at Time', type: 'textarea' },
        ],
      },
      {
        title: 'Third Party Details (if applicable)',
        fields: [
          { key: 'tp_name',            label: 'Third Party Name',           type: 'text' },
          { key: 'tp_phone',           label: 'Third Party Phone',          type: 'text' },
          { key: 'tp_property_damage', label: 'Third Party Property Damaged?', type: 'radio', options: ['Yes', 'No'] },
          { key: 'tp_damage_detail',   label: 'Description of Third Party Damage', type: 'textarea' },
        ],
      },
      {
        title: 'Documents Requested',
        fields: [
          { key: 'docs_checklist', label: 'Confirm items requested from client', type: 'checkbox', options: [
            'Photos of damage',
            'Photos of site / location',
            'Police report (theft / major incidents)',
            'Operator licence / ticket',
            'Pre-loss inspection / service records',
            'Repair quotes',
            'Purchase invoice / proof of value',
            'WorkSafe notification (if applicable)',
          ]},
        ],
      },
      {
        title: 'Broker Actions',
        fields: [
          { key: 'lodged_with_insurer', label: 'Claim Lodged with Insurer?',        type: 'radio', options: ['Yes', 'No'] },
          { key: 'claim_number',        label: 'Claim Number',                      type: 'text' },
          { key: 'assessor_appointed',  label: 'Assessor Appointed?',               type: 'radio', options: ['Yes', 'No', 'Pending'] },
          { key: 'excess_advised',      label: 'Client Advised of Excess?',         type: 'radio', options: ['Yes', 'No'] },
          { key: 'downtime_discussed',  label: 'Downtime / Hire Plant Discussed?',  type: 'radio', options: ['Yes', 'No', 'N/A'] },
          { key: 'diary_task_created',  label: 'Follow-up Diary Task Created?',     type: 'radio', options: ['Yes', 'No'] },
          { key: 'client_updated',      label: 'Client Updated?',                   type: 'radio', options: ['Yes', 'No'] },
          { key: 'additional_notes',    label: 'Additional Notes',                  type: 'textarea' },
        ],
      },
    ],
  },

  // ── FARM ───────────────────────────────────────────────────────────────────
  Farm: {
    label: 'Farm',
    icon: '🌾',
    appliesTo: ['Farm'],
    sections: [
      {
        title: 'Policy Details',
        fields: [
          { key: 'policy_number',  label: 'Policy Number',     type: 'text' },
          { key: 'insured_name',   label: 'Insured Name',      type: 'text' },
          { key: 'contact_number', label: 'Contact Number',    type: 'text' },
          { key: 'email',          label: 'Email Address',     type: 'text' },
          { key: 'farm_address',   label: 'Farm Address',      type: 'text' },
          { key: 'section_triggered', label: 'Policy Section Triggered', type: 'select', options: ['Farm Buildings', 'Farm Contents / Equipment', 'Livestock', 'Crops', 'Farm Motor / Machinery', 'Farm Liability', 'Other'] },
        ],
      },
      {
        title: 'Incident Details',
        fields: [
          { key: 'incident_date',        label: 'Date of Incident',      type: 'date' },
          { key: 'incident_time',        label: 'Time (approx)',         type: 'time' },
          { key: 'incident_location',    label: 'Location on Property',  type: 'text' },
          { key: 'incident_type',        label: 'Cause of Loss',         type: 'select', options: ['Fire', 'Storm / Hail / Flood', 'Theft', 'Livestock Accident / Death', 'Machinery Breakdown / Damage', 'Crop Damage', 'Accidental Damage', 'Liability', 'Other'] },
          { key: 'incident_description', label: 'Full Description',      type: 'textarea' },
          { key: 'police_attended',      label: 'Police Attended?',      type: 'radio', options: ['Yes', 'No'] },
          { key: 'police_event',         label: 'Police Event Number',   type: 'text' },
          { key: 'rural_fire_notified',  label: 'Rural Fire Service Notified? (fire claims)', type: 'radio', options: ['Yes', 'No', 'N/A'] },
        ],
      },
      {
        title: 'Loss Details',
        fields: [
          { key: 'livestock_affected',   label: 'Livestock Affected (type, number, age)', type: 'textarea' },
          { key: 'livestock_value',      label: 'Estimated Value of Livestock Lost',      type: 'text' },
          { key: 'crop_affected',        label: 'Crop Type & Area Affected',              type: 'text' },
          { key: 'crop_value',           label: 'Estimated Crop Loss Value',              type: 'text' },
          { key: 'equipment_damaged',    label: 'Farm Equipment / Machinery Damaged',     type: 'textarea' },
          { key: 'building_damage',      label: 'Building / Structure Damage',            type: 'textarea' },
          { key: 'estimated_total_loss', label: 'Total Estimated Loss Value',             type: 'text' },
          { key: 'vet_attended',         label: 'Vet Attended? (livestock claims)',       type: 'radio', options: ['Yes', 'No', 'N/A'] },
          { key: 'vet_detail',           label: 'Vet Name & Report Reference',            type: 'text' },
        ],
      },
      {
        title: 'Documents Requested',
        fields: [
          { key: 'docs_checklist', label: 'Confirm items requested from client', type: 'checkbox', options: [
            'Photos / video of all loss and damage',
            'Vet report / certificate of death (livestock)',
            'Purchase records / stock inventory (livestock)',
            'Crop yield history / agronomy report',
            'Repair quotes for machinery / buildings',
            'Police report (theft)',
            'Fire brigade / rural fire report',
            'Weather bureau confirmation (storm / hail)',
          ]},
        ],
      },
      {
        title: 'Broker Actions',
        fields: [
          { key: 'lodged_with_insurer', label: 'Claim Lodged with Insurer?',        type: 'radio', options: ['Yes', 'No'] },
          { key: 'claim_number',        label: 'Claim Number',                      type: 'text' },
          { key: 'assessor_appointed',  label: 'Assessor / Loss Adjuster Appointed?', type: 'radio', options: ['Yes', 'No', 'Pending'] },
          { key: 'excess_advised',      label: 'Client Advised of Excess?',         type: 'radio', options: ['Yes', 'No'] },
          { key: 'diary_task_created',  label: 'Follow-up Diary Task Created?',     type: 'radio', options: ['Yes', 'No'] },
          { key: 'client_updated',      label: 'Client Updated?',                   type: 'radio', options: ['Yes', 'No'] },
          { key: 'additional_notes',    label: 'Additional Notes',                  type: 'textarea' },
        ],
      },
    ],
  },

  // ── WORKERS COMPENSATION ───────────────────────────────────────────────────
  WorkersCompensation: {
    label: "Workers' Compensation",
    icon: '👷',
    appliesTo: ["Workers Compensation"],
    sections: [
      {
        title: 'Policy Details',
        fields: [
          { key: 'policy_number',  label: 'Policy Number',       type: 'text' },
          { key: 'insured_name',   label: 'Employer Name',       type: 'text' },
          { key: 'contact_number', label: 'Contact Number',      type: 'text' },
          { key: 'email',          label: 'Email Address',       type: 'text' },
          { key: 'industry',       label: 'Industry / Business Activity', type: 'text' },
          { key: 'state',          label: 'State of Injury',     type: 'select', options: ['QLD','NSW','VIC','SA','WA','TAS','NT','ACT'] },
        ],
      },
      {
        title: 'Injured Worker Details',
        fields: [
          { key: 'worker_name',        label: 'Injured Worker Full Name',     type: 'text' },
          { key: 'worker_dob',         label: 'Date of Birth',                type: 'date' },
          { key: 'worker_address',     label: 'Home Address',                 type: 'text' },
          { key: 'worker_phone',       label: 'Contact Number',               type: 'text' },
          { key: 'employment_type',    label: 'Employment Type',              type: 'select', options: ['Full-time', 'Part-time', 'Casual', 'Contractor', 'Labour Hire'] },
          { key: 'job_role',           label: 'Job Title / Role',             type: 'text' },
          { key: 'employment_start',   label: 'Employment Start Date',        type: 'date' },
          { key: 'weekly_earnings',    label: 'Average Weekly Earnings (gross)', type: 'text' },
        ],
      },
      {
        title: 'Incident / Injury Details',
        fields: [
          { key: 'incident_date',        label: 'Date of Injury',                       type: 'date' },
          { key: 'incident_time',        label: 'Time of Injury',                       type: 'time' },
          { key: 'incident_location',    label: 'Location of Injury',                   type: 'text' },
          { key: 'incident_description', label: 'Detailed Description of How Injury Occurred', type: 'textarea' },
          { key: 'injury_description',   label: 'Nature and Site of Injury',            type: 'textarea' },
          { key: 'injury_type',          label: 'Type of Injury',                       type: 'select', options: ['Muscular / Soft Tissue', 'Fracture / Dislocation', 'Laceration / Wound', 'Burns', 'Disease / Illness', 'Psychological / Mental Health', 'Eye Injury', 'Hearing Loss', 'Other'] },
          { key: 'witnesses',            label: 'Witnesses Present?',                   type: 'radio', options: ['Yes', 'No'] },
          { key: 'witness_details',      label: 'Witness Name & Contact',               type: 'text' },
          { key: 'reported_to_supervisor', label: 'Injury Reported to Supervisor?',     type: 'radio', options: ['Yes', 'No'] },
          { key: 'reported_date',        label: 'Date Reported to Employer',            type: 'date' },
        ],
      },
      {
        title: 'Medical Details',
        fields: [
          { key: 'medical_treatment',  label: 'Medical Treatment Received?',          type: 'radio', options: ['Yes', 'No'] },
          { key: 'treating_doctor',    label: 'Treating Doctor / Hospital',           type: 'text' },
          { key: 'time_off_work',      label: 'Worker Currently Off Work?',           type: 'radio', options: ['Yes', 'No'] },
          { key: 'return_to_work_date',label: 'Expected / Actual Return to Work Date',type: 'date' },
          { key: 'modified_duties',    label: 'Modified / Alternative Duties Available?', type: 'radio', options: ['Yes', 'No'] },
          { key: 'worksafe_notified',  label: 'WorkSafe / WHS Authority Notified?',   type: 'radio', options: ['Yes', 'No', 'N/A'] },
          { key: 'worksafe_reference', label: 'WorkSafe / WHS Reference Number',      type: 'text' },
        ],
      },
      {
        title: 'Documents Requested',
        fields: [
          { key: 'docs_checklist', label: 'Confirm items requested from employer', type: 'checkbox', options: [
            'Incident / Injury report form',
            'Medical certificate from treating doctor',
            'WorkSafe / WHS notification (if required)',
            'Payroll records / wage details',
            'Employment contract',
            'Return to Work plan',
            'Any witness statements',
          ]},
        ],
      },
      {
        title: 'Broker Actions',
        fields: [
          { key: 'lodged_with_insurer',    label: 'Claim Lodged with Insurer?',            type: 'radio', options: ['Yes', 'No'] },
          { key: 'claim_number',           label: 'Claim Number',                          type: 'text' },
          { key: 'case_manager_assigned',  label: 'Case Manager Assigned?',                type: 'radio', options: ['Yes', 'No', 'Pending'] },
          { key: 'rtwp_discussed',         label: 'Return to Work Plan Discussed?',        type: 'radio', options: ['Yes', 'No'] },
          { key: 'diary_task_created',     label: 'Follow-up Diary Task Created?',         type: 'radio', options: ['Yes', 'No'] },
          { key: 'client_updated',         label: 'Employer Updated?',                     type: 'radio', options: ['Yes', 'No'] },
          { key: 'additional_notes',       label: 'Additional Notes',                      type: 'textarea' },
        ],
      },
    ],
  },

  // ── CYBER ──────────────────────────────────────────────────────────────────
  Cyber: {
    label: 'Cyber',
    icon: '🔒',
    appliesTo: ['Cyber'],
    sections: [
      {
        title: 'Policy Details',
        fields: [
          { key: 'policy_number',   label: 'Policy Number',     type: 'text' },
          { key: 'insured_name',    label: 'Insured Name',      type: 'text' },
          { key: 'contact_number',  label: 'Contact Number',    type: 'text' },
          { key: 'email',           label: 'Email Address',     type: 'text' },
          { key: 'it_contact',      label: 'IT Manager / Contact Name', type: 'text' },
          { key: 'claims_made_noted', label: 'Client reminded this is a Claims-Made policy?', type: 'radio', options: ['Yes', 'No'] },
        ],
      },
      {
        title: 'Incident Details',
        fields: [
          { key: 'incident_date',        label: 'Date Incident Occurred (or discovered)', type: 'date' },
          { key: 'incident_type',        label: 'Type of Cyber Incident',                 type: 'select', options: ['Ransomware Attack', 'Data Breach / Exfiltration', 'Business Email Compromise (BEC)', 'Phishing / Social Engineering', 'System Hack / Intrusion', 'Denial of Service (DDoS)', 'Malware / Virus', 'Accidental Data Loss', 'Other'] },
          { key: 'incident_description', label: 'Full Description of What Happened',      type: 'textarea' },
          { key: 'systems_affected',     label: 'Systems / Data Affected',                type: 'textarea' },
          { key: 'business_interrupted', label: 'Business Operations Interrupted?',       type: 'radio', options: ['Yes', 'No'] },
          { key: 'interruption_duration',label: 'Estimated Duration of Interruption',     type: 'text' },
          { key: 'ransom_demanded',      label: 'Ransom Demanded?',                       type: 'radio', options: ['Yes', 'No'] },
          { key: 'ransom_amount',        label: 'Ransom Amount Demanded',                 type: 'text' },
          { key: 'ransom_paid',          label: 'Ransom Paid? (do NOT pay without insurer consent)', type: 'radio', options: ['Yes', 'No', 'Pending'] },
        ],
      },
      {
        title: 'Data & Privacy',
        fields: [
          { key: 'personal_data_affected', label: 'Personal / Sensitive Data Affected?',     type: 'radio', options: ['Yes', 'No', 'Unknown'] },
          { key: 'records_affected',       label: 'Estimated Number of Records Affected',     type: 'text' },
          { key: 'data_types',             label: 'Types of Data Affected',                   type: 'textarea' },
          { key: 'oaic_required',          label: 'OAIC / Privacy Commissioner Notification Required?', type: 'radio', options: ['Yes', 'No', 'Assessing'] },
          { key: 'third_parties_affected', label: 'Third Parties / Clients Affected?',        type: 'radio', options: ['Yes', 'No', 'Unknown'] },
          { key: 'third_party_detail',     label: 'Details of Third Parties Affected',        type: 'textarea' },
        ],
      },
      {
        title: 'Response Actions Taken',
        fields: [
          { key: 'systems_isolated',     label: 'Affected Systems Isolated?',          type: 'radio', options: ['Yes', 'No'] },
          { key: 'it_forensics',         label: 'IT Forensics / Specialist Engaged?',  type: 'radio', options: ['Yes', 'No'] },
          { key: 'it_specialist_detail', label: 'IT Specialist Name & Firm',           type: 'text' },
          { key: 'law_enforcement',      label: 'Australian Federal Police Notified?', type: 'radio', options: ['Yes', 'No'] },
          { key: 'acsc_notified',        label: 'Australian Cyber Security Centre (ACSC) Notified?', type: 'radio', options: ['Yes', 'No'] },
          { key: 'backups_available',    label: 'Clean Data Backups Available?',        type: 'radio', options: ['Yes', 'No', 'Partial'] },
        ],
      },
      {
        title: 'Documents Requested',
        fields: [
          { key: 'docs_checklist', label: 'Confirm items requested from client', type: 'checkbox', options: [
            'IT forensics / incident report',
            'Evidence of ransom demand (do NOT pay without insurer approval)',
            'List of affected systems and data',
            'Logs / records of intrusion',
            'Evidence of business interruption losses',
            'Third party notification correspondence',
            'OAIC / regulator notification (if applicable)',
          ]},
        ],
      },
      {
        title: 'Broker Actions',
        fields: [
          { key: 'lodged_with_insurer',   label: 'Notified Insurer Immediately?',      type: 'radio', options: ['Yes', 'No'] },
          { key: 'claim_number',          label: 'Claim / Reference Number',           type: 'text' },
          { key: 'panel_it_appointed',    label: 'Insurer Panel IT Specialist Appointed?', type: 'radio', options: ['Yes', 'No', 'Pending'] },
          { key: 'no_ransom_warned',      label: 'Client Warned NOT to Pay Ransom Without Insurer Consent?', type: 'radio', options: ['Yes', 'No'] },
          { key: 'excess_advised',        label: 'Client Advised of Excess?',          type: 'radio', options: ['Yes', 'No'] },
          { key: 'diary_task_created',    label: 'Follow-up Diary Task Created?',      type: 'radio', options: ['Yes', 'No'] },
          { key: 'client_updated',        label: 'Client Updated?',                    type: 'radio', options: ['Yes', 'No'] },
          { key: 'additional_notes',      label: 'Additional Notes',                   type: 'textarea' },
        ],
      },
    ],
  },

  // ── TRAVEL ─────────────────────────────────────────────────────────────────
  Travel: {
    label: 'Travel',
    icon: '✈️',
    appliesTo: ['Travel', 'PAC'],
    sections: [
      {
        title: 'Policy Details',
        fields: [
          { key: 'policy_number',  label: 'Policy Number',        type: 'text' },
          { key: 'insured_name',   label: 'Insured Name',         type: 'text' },
          { key: 'contact_number', label: 'Contact Number',       type: 'text' },
          { key: 'email',          label: 'Email Address',        type: 'text' },
          { key: 'departure_date', label: 'Original Departure Date', type: 'date' },
          { key: 'return_date',    label: 'Original Return Date',    type: 'date' },
          { key: 'destination',    label: 'Destination(s)',          type: 'text' },
        ],
      },
      {
        title: 'Claim Details',
        fields: [
          { key: 'claim_type',           label: 'Type of Claim',                  type: 'select', options: ['Medical / Emergency Expenses', 'Trip Cancellation / Curtailment', 'Lost / Stolen / Damaged Baggage', 'Travel Delay', 'Personal Liability', 'Accidental Death / Injury', 'Other'] },
          { key: 'incident_date',        label: 'Date of Incident',               type: 'date' },
          { key: 'incident_location',    label: 'Location of Incident (country / city)', type: 'text' },
          { key: 'incident_description', label: 'Full Description of Incident',   type: 'textarea' },
          { key: 'claim_amount',         label: 'Estimated Claim Amount',         type: 'text' },
        ],
      },
      {
        title: 'Medical Claims (if applicable)',
        fields: [
          { key: 'medical_facility',    label: 'Hospital / Medical Facility Name',  type: 'text' },
          { key: 'medical_treatment',   label: 'Nature of Treatment',               type: 'textarea' },
          { key: 'medical_cost',        label: 'Total Medical Costs',               type: 'text' },
          { key: 'pre_existing',        label: 'Any Pre-Existing Conditions Relevant?', type: 'radio', options: ['Yes', 'No'] },
          { key: 'emergency_assist',    label: 'Emergency Assistance Service Contacted?', type: 'radio', options: ['Yes', 'No'] },
        ],
      },
      {
        title: 'Documents Requested',
        fields: [
          { key: 'docs_checklist', label: 'Confirm items requested from client', type: 'checkbox', options: [
            'Medical reports / invoices / receipts',
            'Airline / transport receipts and booking confirmation',
            'Police report (theft / loss)',
            'Property irregularity report (baggage — from airline)',
            'Cancellation invoices and reason (travel cancellation)',
            'Travel booking confirmation',
            'Evidence of delay (airline letter)',
          ]},
        ],
      },
      {
        title: 'Broker Actions',
        fields: [
          { key: 'lodged_with_insurer', label: 'Claim Lodged with Insurer?',        type: 'radio', options: ['Yes', 'No'] },
          { key: 'claim_number',        label: 'Claim Number',                      type: 'text' },
          { key: 'excess_advised',      label: 'Client Advised of Excess?',         type: 'radio', options: ['Yes', 'No'] },
          { key: 'diary_task_created',  label: 'Follow-up Diary Task Created?',     type: 'radio', options: ['Yes', 'No'] },
          { key: 'client_updated',      label: 'Client Updated?',                   type: 'radio', options: ['Yes', 'No'] },
          { key: 'additional_notes',    label: 'Additional Notes',                  type: 'textarea' },
        ],
      },
    ],
  },

  // ── GENERAL (fallback for types not covered above) ────────────────────────
  General: {
    label: 'General Claim',
    icon: '📋',
    appliesTo: ['Business Package', 'Other'],
    sections: [
      {
        title: 'Policy Details',
        fields: [
          { key: 'policy_number',  label: 'Policy Number',     type: 'text' },
          { key: 'insured_name',   label: 'Insured Name',      type: 'text' },
          { key: 'contact_number', label: 'Contact Number',    type: 'text' },
          { key: 'email',          label: 'Email Address',     type: 'text' },
          { key: 'cover_type',     label: 'Type of Cover',     type: 'text' },
        ],
      },
      {
        title: 'Incident Details',
        fields: [
          { key: 'incident_date',        label: 'Date of Incident',         type: 'date' },
          { key: 'incident_time',        label: 'Time of Incident',         type: 'time' },
          { key: 'incident_location',    label: 'Location of Incident',     type: 'text' },
          { key: 'incident_type',        label: 'Cause / Type of Loss',     type: 'text' },
          { key: 'incident_description', label: 'Full Description',         type: 'textarea' },
          { key: 'police_attended',      label: 'Police Attended?',         type: 'radio', options: ['Yes', 'No'] },
          { key: 'police_event',         label: 'Police Event Number',      type: 'text' },
          { key: 'injuries',             label: 'Any Injuries?',            type: 'radio', options: ['Yes', 'No'] },
          { key: 'estimated_loss',       label: 'Estimated Value of Loss',  type: 'text' },
        ],
      },
      {
        title: 'Documents Requested',
        fields: [
          { key: 'docs_checklist', label: 'Confirm items requested from client', type: 'checkbox', options: [
            'Photos / video of loss or damage',
            'Police report (if applicable)',
            'Repair quotes / invoices',
            'Purchase receipts / proof of ownership',
            'Any third party details',
            'Any witness details',
          ]},
        ],
      },
      {
        title: 'Broker Actions',
        fields: [
          { key: 'lodged_with_insurer', label: 'Claim Lodged with Insurer?',        type: 'radio', options: ['Yes', 'No'] },
          { key: 'claim_number',        label: 'Claim Number',                      type: 'text' },
          { key: 'assessor_appointed',  label: 'Assessor Appointed?',               type: 'radio', options: ['Yes', 'No', 'Pending'] },
          { key: 'excess_advised',      label: 'Client Advised of Excess?',         type: 'radio', options: ['Yes', 'No'] },
          { key: 'diary_task_created',  label: 'Follow-up Diary Task Created?',     type: 'radio', options: ['Yes', 'No'] },
          { key: 'client_updated',      label: 'Client Updated?',                   type: 'radio', options: ['Yes', 'No'] },
          { key: 'additional_notes',    label: 'Additional Notes',                  type: 'textarea' },
        ],
      },
    ],
  },
}

// ── Helper: pick the right questionnaire for a given cover type ────────────
export function getQuestionnaireForCoverType(coverType) {
  if (!coverType) return CLAIM_QUESTIONNAIRES.General
  const ct = coverType.toLowerCase()
  if (['car','commercial motor','truck','motorbike','caravan'].some(t => ct.includes(t))) return CLAIM_QUESTIONNAIRES.Motor
  if (['commercial property','landlord','home & contents','residential strata'].some(t => ct.includes(t))) return CLAIM_QUESTIONNAIRES.Property
  if (ct.includes('public liability')) return CLAIM_QUESTIONNAIRES.PublicLiability
  if (ct.includes('professional indemnity')) return CLAIM_QUESTIONNAIRES.ProfessionalIndemnity
  if (ct.includes('management liability')) return CLAIM_QUESTIONNAIRES.ManagementLiability
  if (['marine','carriers'].some(t => ct.includes(t))) return CLAIM_QUESTIONNAIRES.Marine
  if (['plant','construction','annual works','single project','owner builder'].some(t => ct.includes(t))) return CLAIM_QUESTIONNAIRES.PlantEquipment
  if (ct.includes('farm')) return CLAIM_QUESTIONNAIRES.Farm
  if (['workers compensation','workers comp'].some(t => ct.includes(t))) return CLAIM_QUESTIONNAIRES.WorkersCompensation
  if (ct.includes('cyber')) return CLAIM_QUESTIONNAIRES.Cyber
  if (['travel','pac'].some(t => ct.includes(t))) return CLAIM_QUESTIONNAIRES.Travel
  return CLAIM_QUESTIONNAIRES.General
}
